import { createPortal } from "react-dom"
import classNames from "classnames"
import styled from "styled-components"

import styles from "assets/scss/index.module.scss"
import { ReactComponent as IconDelete } from "assets/svg/modal-icon-delete.svg"

import { ModalLayout } from "layouts/ModalLayout"

const IconContainer = styled.span`
  width: 24px;
  height: 24px;
  display: inline-block;
  padding-top: 10px;
  background-color: #fee2e2;
  border-radius: 10px;
  width: 40px;
  height: 40px;

  svg {
    path {
      stroke: #b91c1c;
    }
  }
`

interface Props {
  title?: string
  message?: string
  isFetching?: boolean
  confirmButtonText?: string
  icon?: React.ReactNode
  onCancel?: () => void
  onConfirm?: (event: React.FormEvent<HTMLElement>) => void
}

export const DeleteModal = ({ onCancel, onConfirm, title, message, isFetching, confirmButtonText, icon }: Props) => {
  return (
    <>
      {createPortal(
        <ModalLayout
          width="450px"
          confirmButtonColor="red"
          isFetching={isFetching}
          confirmButtonText={confirmButtonText}
          onConfirm={onConfirm}
          onCancel={onCancel}
        >
          <div className={classNames(styles.modalContent, styles.center)}>
            {icon ? <IconContainer>{icon}</IconContainer> : <IconDelete />}
            <h3 className={styles.modalTitle}>{title}</h3>
            <div className={styles.modalMessage}>{message}</div>
          </div>
        </ModalLayout>,
        document.body,
      )}
    </>
  )
}
